import React from 'react';
import styled from 'styled-components';

const CTASection: React.FC = () => {
  return (
    <Container className="apoplsp">
      <MainWrapper>
        <CTABox>
          <CTAHeader>Still have doubts? <span style={{color:'#784dcc'}}>We've got you Covered.</span></CTAHeader>
          <CTAButtons>
            <button   
              onClick={() => window.location.href = "mailto:info@tradesimple.ca"}
              className="button-prim"
            >
              <div style={{
                display: "flex",
                fontSize: 16,
                justifyContent: "center",
                alignItems: "center",
                margin: 0,
                padding: 0,
              }}>
                Contact Us
              </div>
            </button>
          </CTAButtons>
        </CTABox>
      </MainWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 60px 20px;
  background: #E7ECF9;
`;

const MainWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const CTABox = styled.div`
  background: #fff;
  border-radius: 15px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const CTAHeader = styled.h2`
  font-size: 32px;
  font-family: var(--font-bold);
  color: #333;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 20px;
  }
`;

const CTAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export default CTASection;

